import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../redux/hooks";
import { setFader } from "../../redux/states/fader/faderSlice";

export const useCustomNavigation = () => {
  let navigate = useNavigate();
  const reduxDispatch = useAppDispatch();

  const customNavigation = useCallback(
    (to: string, animation: boolean = true) => {
      if (animation) {
        reduxDispatch(setFader({ fading: true }));
        //Wait the same amount of transition: opacity set on .main
        setTimeout(() => {
          window.scrollTo(0, 0); //Restore scroll to top
          navigate("/" + to, { replace: true });
          reduxDispatch(setFader({ fading: false }));
        }, 600);
      } else {
        navigate("/" + to, { replace: true });
      }
    },
    [navigate, reduxDispatch]
  );

  return { customNavigation };
};
